export interface DiscountCode {
  _id?: string;
  code?: string;
  type?: DiscountCodeType;
  expiresAt?: Date;
  discount?: number;
  numberOfUsages?: number;
  usedBy?: Array<string>;
}
export enum DiscountCodeType {
  DISCOUNTED_PURCHASE = "Discounted Purchase",
  FREE_GAME = "Free Game",
}

export interface DiscountCodeCheckRedeemableRequestModel {
  type: string;
  code: string;
}

export interface DiscountCodeCheckRedeemableResponseModel {
  canBeUsed: boolean;
  message?: string;
  discountCodeId?: string;
  discount?: number;
}

export function sampleDiscountCodes(): Array<DiscountCode> {
  const date = new Date();
  date.setDate(new Date().getDate() + 2);
  return [
    {
      _id: "1",
      code: crypto.randomUUID(),
      type: DiscountCodeType.DISCOUNTED_PURCHASE,
      expiresAt: new Date(),
      discount: 20,
      numberOfUsages: 22,
      usedBy: ["", ""],
    },
    {
      _id: "2",
      code: crypto.randomUUID(),
      type: DiscountCodeType.DISCOUNTED_PURCHASE,
      numberOfUsages: 50,
      discount: 50,
    },
    {
      _id: "3",
      code: crypto.randomUUID(),
      type: DiscountCodeType.DISCOUNTED_PURCHASE,
      expiresAt: date,
      discount: 8,
      usedBy: ["", ""],
    },
    {
      _id: "4",
      code: crypto.randomUUID(),
      type: DiscountCodeType.FREE_GAME,
      usedBy: ["", ""],
    },
    {
      _id: "6",
      code: crypto.randomUUID(),
      type: DiscountCodeType.DISCOUNTED_PURCHASE,
      numberOfUsages: 50,
      discount: 50,
    },
    {
      _id: "7",
      code: crypto.randomUUID(),
      type: DiscountCodeType.DISCOUNTED_PURCHASE,
      expiresAt: date,
      discount: 8,
      usedBy: ["", ""],
    },
    {
      _id: "8",
      code: crypto.randomUUID(),
      type: DiscountCodeType.FREE_GAME,
      usedBy: ["", ""],
    },
    {
      _id: "5",
      code: crypto.randomUUID(),
      type: DiscountCodeType.DISCOUNTED_PURCHASE,
      expiresAt: new Date(),
      discount: 20,
      numberOfUsages: 22,
      usedBy: ["", ""],
    },
  ];
}
